import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Helpers } from '../../../../../../helpers';
import { BaseComponent } from '../../../base.component';
import { UserGroupService } from '../../../../../../services/user-group.service';
import { PublisherDetailTab } from '../../../owner/publisher-detail/publisher-detail.component';
import { RoleService } from '../../../../../../services/roles.service';
import { UserGroup, UserGroupRole } from '../../../../../../models/user-group';
import { SelectService } from '../../../../../../_services/select.service';
import { Role } from '../../../../../../models/role';
import { DataService } from '../../../../../../_services/data.service';
import { Paths } from '../../../../../../models/enums';

@Component({
    selector: 'app-create-user-group',
    templateUrl: './create-user-group.component.html',
    encapsulation: ViewEncapsulation.None
})
export class CreateUserGroupComponent extends BaseComponent implements OnInit {
    userGroup: UserGroup = new UserGroup();
    roles: any[] = [];
    returnUrl: string;
    publisherName: string;

    constructor(
        private userGroupService: UserGroupService,
        private roleService: RoleService,
        private selectService: SelectService,
        private router: Router,
        private route: ActivatedRoute,
        private dataService: DataService
    ) {
        super();

        this.userGroup.publisherId = route.snapshot.queryParams.publisherId;
        this.returnUrl = route.snapshot.queryParams.returnUrl;
        this.publisherName = route.snapshot.queryParams.publisherName;
        this.buildBreadcrumb(route);
    }

    buildBreadcrumb(route) {
        route.snapshot.parent.data.url = '/' + this.returnUrl;
        if (this.dataService.path == Paths.Owner) {
            route.snapshot.parent.data.queryParams = {
                tab: PublisherDetailTab.UserGroup,
                name: this.publisherName
            };
            route.snapshot.parent.parent.data.url = '/' + this.returnUrl;
            route.snapshot.parent.parent.data.breadcrumb = this.publisherName;
            route.snapshot.parent.parent.data.queryParams = {
                name: this.publisherName
            };
        }
    }

    ngOnInit() {
        this.getRoles();
    }

    getRoles() {
        Helpers.setLoading(true);
        this.roleService.list().subscribe(res => {
            Helpers.setLoading(false);
            this.roles = res.data;
        });
    }

    navigate() {
        let queryParams = {};
        if (this.dataService.path == Paths.Owner) {
            queryParams['name'] = this.publisherName;
            queryParams['tab'] = PublisherDetailTab.UserGroup;
        }
        this.router.navigate([this.returnUrl], {
            queryParams: queryParams
        });
    }

    validate(event) {
        var customRules = this.validationService.customRules;
        return this.validationService.validate(event, {
            rules: {
                name: customRules.requiredText,
                roles: {
                    required: true,
                    minlength: 1
                }
            },
            messages: {
                roles: 'Please select at least one role'
            },
            errorPlacement: function(error, element) {
                if (element.attr('type') == 'checkbox') {
                    error.insertAfter(
                        $(element)
                            .parents('div')
                            .first()
                    );
                }
            }
        });
    }

    setRoles() {
        let selectedRoles = this.roles.filter(role => role.checked);

        if (selectedRoles.length)
            this.userGroup.userGroupRoles = this.mapRoles(selectedRoles);
    }

    mapRoles(roles): UserGroupRole[] {
        var mappedSizeList: UserGroupRole[] = [];

        for (let role of roles) {
            var newRole: UserGroupRole = new UserGroupRole();
            newRole.roleId = role.id;
            newRole.userGroupId = this.userGroup.id;
            mappedSizeList.push(newRole);
        }
        return mappedSizeList;
    }

    createUserGroup() {
        var _self = this;
        Helpers.setLoading(true);
        this.setRoles();
        this.userGroupService.create(this.userGroup).subscribe(() => {
            Helpers.setLoading(false);
            this.swalService.successCreate();
            setTimeout(function() {
                _self.navigate();
            }, 1000);
        });
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/theme/pages/default/shared/user-group/create-user-group/create-user-group.component.ts